import { render, staticRenderFns } from "./DropdownBinder.vue?vue&type=template&id=ae80b9ca&scoped=true&"
import script from "./DropdownBinder.vue?vue&type=script&lang=js&"
export * from "./DropdownBinder.vue?vue&type=script&lang=js&"
import style0 from "./DropdownBinder.vue?vue&type=style&index=0&id=ae80b9ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae80b9ca",
  null
  
)

export default component.exports